import {Inject, Injectable} from '@angular/core';
import PocketBase, {RecordService} from 'pocketbase';
import {Environment} from "../environments/ienvironment";
import {ENV} from "../environments/environment.provider";

@Injectable({
  providedIn: 'root'
})
export class PocketbaseService {

  pb = new PocketBase(this.env.pocketbaseUrl) as TypedPocketBase;

  constructor(@Inject(ENV) private env: Environment) {
    this.pb.autoCancellation(false);
  }

  async authUser(username: string, password: string){
    await this.pb.collection('users').authWithPassword(username, password).catch(err=>console.log(err));
  }

  async getAllUser(): Promise<Array<PBSelectUser>>{
    return this.pb.collection('users').getFullList();
  }

  async getAllTopics(): Promise<Array<PBTopic>>{
    return this.pb.collection('topic').getFullList()
  }

  async getUser():Promise<PBSelectUser>{
    return this.pb.collection('users').getFirstListItem(`id="${this.pb.authStore.record?.id}"`)
  }

}
export interface PBReason {
  id: String,
  title: String,
  topic: String,
  description: String,
  forUser: String,
  createdFrom: String
}

export interface PBSelectUser{
  id: String,
  username: String,
  avatar: String
}

export interface PBSaved{
  id:String,
  reason:String[],
  user:String
}

export interface PBTopic{
  id: String,
  topicname: String
}
interface TypedPocketBase extends PocketBase {
  collection(idOrName: string): RecordService // default fallback for any other collection
  collection(idOrName: 'reason'): RecordService<PBReason>
  collection(idOrName: 'users'): RecordService<PBSelectUser>
  collection(idOrName: 'topic'): RecordService<PBTopic>
  collection(idOrName: 'saved'): RecordService<PBSaved>
}
